import axios from 'axios';
import URLs from '@/config/constants';

// eslint-disable-next-line import/prefer-default-export
export const verifyCi = async payload => axios.post(URLs.GetVerifyCI,
  payload, {
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
      Authorization: process.env.VUE_APP_TOKEN_TEMP,
    },
  }).then((resp) => {
  if (resp.status === 200) { return Promise.resolve(resp); }
  const responde = { response: { status: resp.status } };
  return Promise.reject(responde);
}).catch((resp) => {
  const responde = { response: { status: resp.response.status } };
  return Promise.reject(responde);
});
